import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

const StyledPlatformForExportImage = styled('span')(
  () => css`
    display: none;
    white-space: pre;
  `
);

export default StyledPlatformForExportImage;
